import { memo } from 'react';
import { isNativeAsset } from '../UploadImages.utils';
import { UploadedImagesProps } from './UploadedImages.types';
import { CONTENT_CONTAINER_STYLE } from './UploadedImages.content';
import UploadedImage from './UploadedImage/UploadedImage';
import ScrollView from '../../ScrollView/ScrollView';

function UploadedImages({ images, onDelete }: UploadedImagesProps) {
  return (
    <ScrollView contentContainerStyle={CONTENT_CONTAINER_STYLE} horizontal>
      {images.map((image, index) => (
        <UploadedImage
          key={index}
          index={index}
          type={image.type}
          fileName={isNativeAsset(image) ? image.fileName : image.name}
          onDelete={onDelete}
        />
      ))}
    </ScrollView>
  );
}

export default memo(UploadedImages);
